import { useMutation } from '@tanstack/react-query';
import createPrivateAdminPanelInstance from '../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../api/ApiRoutes';

const fetchTransactionDetails = async ({ transaction_id, user_id }) => {
  if (!transaction_id) return;

  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.GET_TRANSACTION_DETAILS,
    {
      transaction_id,
      user_id,
    }
  );

  return response?.data?.data ?? null;
};

export const useGetTransactionDetails = () => {
  return useMutation({
    mutationKey: ['GET_TRANSACTION_DETAILS'],
    mutationFn: fetchTransactionDetails,
  });
};
